import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { DatePicker, message, Tooltip, TimePicker, Select, Input } from "antd";
import moment from "moment";
import DataParser from "../../../utlits/Dataparser";
import LeaveApplicationService from "../../../Services/LeaveApplicationService";
import LeaveSessionService from "../../../Services/LeaveSessionService";
import LeaveEntitlementService from "../../../Services/LeaveEntitlementService";
import CompanyService from "../../../Services/CompanyService";
import shortid from "shortid";
import PhyicalYearService from "../../../Services/PhyicalYearService";
import LeavetypeService from "../../../Services/PolicyServices"; // fetch user-specific policies
import HolidayService from "../../../Services/HolidayService";

import PastDaysService from "../../../Services/PastDaysService";
import SocketService from "../../../Services/SocketService";

const { Option } = Select;
const { TextArea } = Input;

const AddLeavesHr = (props) => {
  const { id, labelledby, userLeaveCheck, getLeaveApplicationsAll } = props;

  const [leaveType, setLeaveType] = useState(null); // will store numeric policy id (policy_id or id)
  const [selectedUser, setSelectedUser] = useState(null);
  const [fromDate, setFromDate] = useState(null);

  const [toDate, setToDate] = useState(null);
  const [numberOfDays, setNumberOfDays] = useState(0);
  const [leavesDates, setLeavesDates] = useState([]);
  const [companyUserList, setCompanyUserList] = useState([]);
  const [dataSubmitting, setDataSubmitting] = useState(false);

  const [userLeaves, setUserLeaves] = useState([]);
  const [userLeavesssss, setUserLeavesssss] = useState([]);
  const [leaveReason, setLeaveReason] = useState("");
  const [activeSession, setActiveSession] = useState(null);
  const compid = DataParser.CompanyId();

  const [leavePolicyList, setLeavePolicyList] = useState([]); // policies for the selected employee
  const [selectedPolicyObj, setSelectedPolicyObj] = useState(null); // full selected policy object
  const [leaveSessionId, setLeaveSessionId] = useState(""); // physical year id if needed
  const [pastDaysLimit, setPastDaysLimit] = useState(0);

  // 🟢 Half Day States
  const [leaveMode, setLeaveMode] = useState("full"); // "full" | "half"
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [halfDayType, setHalfDayType] = useState("1st Half");
  const [totalTimeDisplay, setTotalTimeDisplay] = useState("");

  const companyId = DataParser.CompanyId();



  // --- initial: set default dates, fetch company users, set physical year info ---
  useEffect(() => {
    const datee = DataParser.getDateinFormat();
    getCompanyUsers();
    setFromDate(moment(datee));
    setToDate(moment(datee));

    // fetch active leave session id for submissions
    PhyicalYearService.getPhysicalYear(compid)
      .then((res) => {
        const data = res.data.Settings?.[0]?.id;
        if (data) setLeaveSessionId(data);
      })
      .catch((err) => {
        // ignore
      });

    LeaveSessionService.getLeaveSeassions(companyId)
      .then((res) => {
        const data = res.data.Leave_sessions?.filter((el) => el.status === 1);
        if (data && data.length) setActiveSession(data[0].id);
      })
      .catch(() => { });

    // Fetch Past Days Setting
    PastDaysService.getPastDays(companyId).then((res) => {
      const data = res.data || [];
      if (Array.isArray(data) && data.length > 0) {
        setPastDaysLimit(data[0].days);
      } else {
        setPastDaysLimit(0);
      }
    }).catch(err => {
      console.error("Error fetching past days:", err);
    });
  }, []);



  const getCompanyUsers = () => {
    CompanyService.getComapnyUserActive(companyId)
      .then((res) => {
        const data = res.data.user || [];
        setCompanyUserList(data);
      })
      .catch((err) => {
        console.error("Error fetching users:", err);
      });
  };

  // when HR selects an employee, fetch that user's leave policies and entitlements
  useEffect(() => {
    if (!selectedUser) {
      setLeavePolicyList([]);
      setSelectedPolicyObj(null);
      setLeaveType(null);
      setUserLeavesssss([]); // reset user leaves too
      return;
    }

    // 1️⃣ Fetch user-specific leave policies
    LeavetypeService.getUserLeavePolicy(companyId, selectedUser)
      .then((res) => {
        console.log("📦 Full API Response:", res.data);
        const payload = res.data;
        if (Array.isArray(payload)) {
          setLeavePolicyList(payload);
        } else if (payload?.success && Array.isArray(payload.data)) {
          setLeavePolicyList(payload.data);
        } else if (payload?.Leave_policies && Array.isArray(payload.Leave_policies)) {
          setLeavePolicyList(payload.Leave_policies);
        } else {
          setLeavePolicyList([]);
        }
        setLeaveType(null);
        setSelectedPolicyObj(null);
        setFromDate(moment(DataParser.getDateinFormat()));
        setToDate(moment(DataParser.getDateinFormat()));
      })
      .catch((err) => {
        console.error("Error fetching user policies:", err);
        setLeavePolicyList([]);
      });

    // 2️⃣ Fetch user leave applications
    const fetchUserLeaves = async () => {
      try {
        const res = await LeaveApplicationService.getLeaveApplicationUser(selectedUser, companyId, {});
        const leaves = res.data?.leave_applications || [];
        setUserLeavesssss(leaves);
      } catch (err) {
        console.error("❌ Error fetching user leaves:", err);
        setUserLeavesssss([]);
      }
    };

    fetchUserLeaves();
  }, [selectedUser, companyId]);

  // 🟢 Socket Integration
  useEffect(() => {
    SocketService.connect();

    const handleLeaveUpdate = (data) => {
      if (String(data.company_id) === String(companyId)) {
        // Only refresh if the update is for the currently selected user
        if (selectedUser && String(data.user_id) === String(selectedUser)) {
          console.log("🔔 Real-time leave update received in AddLeavesHr for:", selectedUser);

          // Refetch policies (balances)
          LeavetypeService.getUserLeavePolicy(companyId, selectedUser)
            .then((res) => {
              const payload = res.data;
              if (Array.isArray(payload)) {
                setLeavePolicyList(payload);
              } else if (payload?.success && Array.isArray(payload.data)) {
                setLeavePolicyList(payload.data);
              } else if (payload?.Leave_policies && Array.isArray(payload.Leave_policies)) {
                setLeavePolicyList(payload.Leave_policies);
              } else {
                setLeavePolicyList([]);
              }
            })
            .catch((err) => console.error("Error refreshing policies in AddLeavesHr:", err));

          // Refetch user leaves
          LeaveApplicationService.getLeaveApplicationUser(selectedUser, companyId, {})
            .then((res) => {
              const leaves = res.data?.leave_applications || [];
              setUserLeavesssss(leaves);
            })
            .catch((err) => console.error("Error refreshing user leaves in AddLeavesHr:", err));
        }
      }
    };

    SocketService.on("leave_update", handleLeaveUpdate);

    return () => {
      SocketService.off("leave_update", handleLeaveUpdate);
    };
  }, [selectedUser, companyId]);

  useEffect(() => {
    if (!leaveType) {
      setSelectedPolicyObj(null);
      return;
    }
    const numId = Number(leaveType);
    const found =
      leavePolicyList.find((p) => p.leave_policy_id === numId) ||
      leavePolicyList.find((p) => p.policy_id === numId) ||
      leavePolicyList.find((p) => p.id === numId) ||
      null;
    setSelectedPolicyObj(found);
    setFromDate(moment(DataParser.getDateinFormat()));
    setToDate(moment(DataParser.getDateinFormat()));
    setNumberOfDays(0);
    setLeavesDates([]);
  }, [leaveType, leavePolicyList]);

  // 🟢 Helper: Check Alternate Day Logic
  const isAlternateOff = (policyDay, dateInput) => {
    if (!policyDay || !policyDay.active) return true;
    if (!policyDay.alternate || !policyDay.alternate_type) return false;

    // Standardize input date
    const date = moment(dateInput, ["YYYY-MM-DD", "DD-MM-YYYY", "MM-DD-YYYY"]);
    if (!date.isValid()) return false;

    // Standardize policy base date
    const baseDate = moment(policyDay.alternate, ["YYYY-MM-DD", "DD-MM-YYYY", "MM-DD-YYYY"]);
    if (!baseDate.isValid()) return false;

    // ❌ BLOCKING CHECK RESTORED: Prevent checking past dates
    if (date.isBefore(baseDate)) return false;

    // Day name check (ensure we are comparing same weekdays)
    if (date.format('dddd').toLowerCase() !== baseDate.format('dddd').toLowerCase()) return false;

    // Calculate week difference (can be negative for past dates)
    const diffWeeks = date.diff(baseDate, "weeks");

    const cycleMap = {
      alternate: 2,       // Every 2 weeks
      bialternate: 3,     // Every 3 weeks
      trialternate: 4,    // Every 4 weeks
      "monthly alternate": 5 // Every 5 weeks (~monthly)
    };

    const cycle = cycleMap[policyDay.alternate_type?.toLowerCase()] || 2;
    const status = policyDay.status || 'off'; // 'off' means the Base Date is an OFF day

    if (status === 'off') {
      return diffWeeks % cycle === 0;
    } else {
      return diffWeeks % cycle !== 0;
    }
  };

  const isOffOrHoliday = (mDate) => {
    if (!selectedPolicyObj) return false;

    const d = mDate.format("YYYY-MM-DD");
    const holidays = selectedPolicyObj.holidays || [];

    // 1️⃣ Check static holidays
    if (holidays.includes(d)) return true;

    // 2️⃣ Check dynamic logic from attendance_days (Shifts)
    if (selectedPolicyObj.attendance_days && Array.isArray(selectedPolicyObj.attendance_days)) {
      const dayName = mDate.format("dddd").toLowerCase();
      const policyDay = selectedPolicyObj.attendance_days.find(p => p.day.toLowerCase() === dayName);

      if (policyDay) {
        // 🟢 If day is explicitly marked as inactive, it's an OFF day
        if (!policyDay.active) return true;

        // 🟢 If active, check if it's an alternate OFF day
        if (isAlternateOff(policyDay, mDate)) return true;
      }
    }

    // 3️⃣ Fallback to static off_days (legacy support)
    const weekOffs = (selectedPolicyObj.off_days || [0, 6]).map((day) =>
      Number(day) === 7 ? 0 : Number(day)
    );

    return weekOffs.includes(mDate.day());
  };


  const getMaxAllowedToDate = (fromDate) => {
    if (!fromDate || !selectedPolicyObj) return null;

    const remainingLeaves = Number(selectedPolicyObj.remaining_leaves) || 0;
    const consecutiveAllowed = Number(selectedPolicyObj.consecutive_allowed) || 1;
    const maxConsec = Math.min(remainingLeaves, consecutiveAllowed);

    let workingDaysCount = 1; // count the fromDate as the first valid day
    let cur = moment(fromDate).clone().startOf("day");

    // loop until we've counted all allowed working days
    while (workingDaysCount < maxConsec) {
      cur.add(1, "day"); // go to next day
      if (!isOffOrHoliday(cur)) {
        workingDaysCount++;
      }
    }

    return cur; // ✅ this is now the true last selectable working day
  };



  const getAllowedDateRange = () => {
    if (!selectedPolicyObj) return [null, null];

    const sessionStart = moment(selectedPolicyObj.leave_session?.start_date);
    const sessionEnd = moment(selectedPolicyObj.leave_session?.end_date);

    // ✅ Universally apply Past Days Logic
    const now = moment().startOf("day");

    // ✅ Find 'pastDaysLimit' valid working days before today (skipping off/holidays)
    let start = now.clone();
    let validDaysCount = 0;

    while (validDaysCount < pastDaysLimit) {
      start.subtract(1, "day");
      // Only count if it's NOT an off day or holiday
      if (!isOffOrHoliday(start)) {
        validDaysCount++;
      }
    }

    // ✅ Ensure start is not before session start date
    if (start.isBefore(sessionStart)) start = sessionStart.clone();

    // Default return to full session end available for future dates
    return [start, sessionEnd];
  };


  const [minDate, maxDate] = getAllowedDateRange();

  useEffect(() => {
    if (!fromDate || (leaveMode === "full" && !toDate)) {
      setLeavesDates([]);
      setNumberOfDays(0);
      return;
    }

    const start = moment(fromDate).startOf("day");

    // 🔵 Half Day Logic
    if (leaveMode === "half") {
      setLeavesDates([start.format("YYYY-MM-DD")]);
      setNumberOfDays(0.5); // Always 0.5 for half day

      // 🔵 Auto-calculate End Time and Total Time
      if (selectedPolicyObj && selectedPolicyObj.attendance_days) {
        const dayName = start.format("dddd").toLowerCase();
        const dayPolicy = selectedPolicyObj.attendance_days.find(d => d.day.toLowerCase() === dayName);

        if (dayPolicy && dayPolicy.active) {
          const getMinutes = (time) => {
            if (!time) return 0;
            // Handle moment objects or string times
            const m = moment.isMoment(time) ? time : moment(time, ["HH:mm", "h:mm A", "HH:mm:ss"]);
            return m.hours() * 60 + m.minutes();
          };

          const policyStartMin = getMinutes(dayPolicy.start);
          const policyEndMin = getMinutes(dayPolicy.end);

          let dayLunchMinutes = 0;
          if (dayPolicy.lunch_times && dayPolicy.lunch_times.length > 0) {
            dayPolicy.lunch_times.forEach(lt => {
              dayLunchMinutes += (getMinutes(lt.end) - getMinutes(lt.start));
            });
          }

          const totalWorkingMinutes = (policyEndMin - policyStartMin) - dayLunchMinutes;
          const halfDayMinutes = totalWorkingMinutes / 2;

          // Update Total Time Display
          const h = Math.floor(halfDayMinutes / 60);
          const m = Math.round(halfDayMinutes % 60);
          setTotalTimeDisplay(`${h}h ${m}m`);

          // 🟠 Auto-set Start Time if missing or if halfDayType changed
          let currentStart = startTime;
          if (!currentStart) {
            if (halfDayType === "1st Half") {
              currentStart = moment(dayPolicy.start, ["HH:mm", "h:mm A"]);
              setStartTime(currentStart);
            } else {
              // 2nd Half: Start after 1st half + lunch
              const halfWay = policyStartMin + halfDayMinutes + dayLunchMinutes;
              currentStart = moment().startOf('day').add(halfWay, 'minutes');
              setStartTime(currentStart);
            }
          }

          if (currentStart) {
            const startMin = getMinutes(currentStart);
            let tentativeEndMin = startMin + halfDayMinutes;

            // Calculate lunch overlap within the proposed range
            let overlapMinutes = 0;
            if (dayPolicy.lunch_times && dayPolicy.lunch_times.length > 0) {
              dayPolicy.lunch_times.forEach(lt => {
                const lStart = getMinutes(lt.start);
                const lEnd = getMinutes(lt.end);
                // Smart Overlap Calculation
                const oStart = Math.max(startMin, lStart);
                const oEnd = Math.min(tentativeEndMin + overlapMinutes, lEnd);
                if (oEnd > oStart) {
                  overlapMinutes += (oEnd - oStart);
                }
              });
            }

            // Set final End Time
            const finalEndMoment = currentStart.clone().add(halfDayMinutes + overlapMinutes, 'minutes');
            setEndTime(finalEndMoment);
          }
        }
      } else {
        setTotalTimeDisplay("");
        setEndTime(null);
      }
      return;
    }

    // 🟢 Full Day Logic
    const end = moment(toDate).startOf("day");
    if (end.isBefore(start)) {
      setLeavesDates([]);
      setNumberOfDays(0);
      return;
    }

    const dates = [];
    let cur = start.clone();
    while (!cur.isAfter(end)) {
      if (!isOffOrHoliday(cur)) dates.push(cur.format("YYYY-MM-DD"));
      cur.add(1, "day");
    }

    setLeavesDates(dates);
    setNumberOfDays(dates.length);
  }, [fromDate, toDate, selectedPolicyObj, leaveMode, startTime, endTime, halfDayType]);

  // --- Disable From date correctly (block holidays & off-days) ---
  const disabledFromDate = (current) => {
    if (!selectedPolicyObj) return false;
    if (!minDate || !maxDate) return false;

    const min = minDate.clone().startOf("day");
    const max = maxDate.clone().endOf("day");

    return current < min || current > max || isOffOrHoliday(current);
  };

  // --- Disable To date correctly (block holidays & off-days, respect consecutive_allowed) ---
  const disabledToDate = (current) => {
    if (!selectedPolicyObj || !fromDate) return false;

    const fd = moment(fromDate).startOf("day");
    const cur = moment(current).startOf("day");
    const maxAllowed = getMaxAllowedToDate(fd);

    // disable if before from date, after maxAllowed, or an off/holiday
    return cur.isBefore(fd) || (maxAllowed && cur.isAfter(maxAllowed)) || isOffOrHoliday(cur);
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedUser) {
      message.error("Please select an employee.");
      return;
    }

    if (!selectedPolicyObj) {
      message.error("Please select a leave type for this employee.");
      return;
    }

    if (leaveMode === "full" && (!fromDate || !toDate)) {
      message.error("Please select From and To dates.");
      return;
    }

    if (leaveMode === "half") {
      if (!fromDate) {
        message.error("Please select Start Date.");
        return;
      }
      if (!startTime) {
        message.error("Please select Start Time.");
        return;
      }
    }

    const remainingLeaves = Number(selectedPolicyObj.remaining_leaves ?? 0);
    if (remainingLeaves <= 0) {
      message.error("No remaining leaves available for this leave type.");
      return;
    }

    if (numberOfDays > remainingLeaves) {
      message.error(`You can only apply up to ${remainingLeaves} leaves for this type.`);
      return;
    }

    const consecAllowed = Number(selectedPolicyObj.consecutive_allowed) || 1;
    if (numberOfDays > consecAllowed) {
      message.error(`Consecutive allowed for this type is ${consecAllowed} day(s).`);
      return;
    }

    // make sure userLeaves is always an array
    // const leavesArray = Array.isArray(userLeavesssss) ? userLeavesssss : [];

    const overlappingDates = leavesDates.filter((date) => {
      const formattedDate = moment(date).format("YYYY-MM-DD");

      return userLeavesssss.some((leave) => {
        const empMatch = leave.empid == selectedUser;
        const statusMatch = [0, 1].includes(Number(leave.status)); // pending or approved

        // ensure leavedates is a proper array
        const leaveDatesArray = Array.isArray(leave.leavedates)
          ? leave.leavedates.map((d) => moment(d).format("YYYY-MM-DD"))
          : [];

        // check overlap
        const overlap = leaveDatesArray.includes(formattedDate);

        return empMatch && statusMatch && overlap;
      });
    });

    if (overlappingDates.length > 0) {
      message.error(
        `You have already applied leave for date(s): ${overlappingDates.join(", ")}`
      );
      return;
    }


    setDataSubmitting(true);

    const body = {
      company_id: companyId,
      reason: leaveReason,
      empid: selectedUser,
      from_date: moment(fromDate).format("YYYY-MM-DD"),
      to_date: leaveMode === "half" ? moment(fromDate).format("YYYY-MM-DD") : moment(toDate).format("YYYY-MM-DD"),
      totalleaves: numberOfDays,
      typ: selectedPolicyObj.leave_policy_id || selectedPolicyObj.policy_id || selectedPolicyObj.id,
      leavesession: activeSession || leaveSessionId,
      leavedates: leavesDates,
      leave_mode: leaveMode,
      half_day_type: leaveMode === "half" ? halfDayType : null,
      start_time: startTime ? moment(startTime).format("HH:mm") : null,
      end_time: endTime ? moment(endTime).format("HH:mm") : null,
    };

    LeaveApplicationService.applyLeave(body)
      .then((res) => {
        if (res.Good) {
          message.success("Leave applied successfully!");
          document.getElementById("closeLeave")?.click();
          getLeaveApplicationsAll?.();
          setDataSubmitting(false);

          setLeaveReason("");
          setLeaveType(null);
          setSelectedUser(null);
          setFromDate(moment(DataParser.getDateinFormat()));
          setToDate(null);
        } else {
          message.error(res.data || "Failed to apply leave.");
          setDataSubmitting(false);
        }
      })
      .catch((err) => {
        console.error("Error applying leave:", err);
        message.error("Failed to apply leave.");
        setDataSubmitting(false);
      });
  };

  return (
    <div
      className="modal fade"
      id={id}
      tabIndex={-1}
      role="dialog"
      aria-hidden="true"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
          {/* Header */}
          <div className="modal-header border-0 pb-1">
            <h5 className="modal-title fw-semibold" style={{ fontSize: "16px", color: "#1D1D1D" }}>Add Employee Leave</h5>
            <button
              type="button"
              className="btn-close shadow-none"
              id="closeLeave"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setSelectedUser(null);
                setLeaveType(null);
                setLeaveReason("");
              }}
            />
          </div>

          <form onSubmit={handleSubmit}>
            <div className="modal-body pt-2 pb-2">
              <div className="row">
                {/* Employee Name */}
                <div className="col-12 mb-3">
                  <div className={`float-select-wrap ${selectedUser ? "has-value" : ""}`}>
                    <label>
                      Employee Name*
                      <Tooltip title="Select the employee's name for whom you want to apply for leave." placement="top">
                        <i className="fa fa-info-circle float-label-helper-icon" />
                      </Tooltip>
                    </label>
                    <Select
                      showSearch
                      placeholder=""
                      optionFilterProp="children"
                      value={selectedUser || undefined}
                      onChange={(val) => setSelectedUser(val)}
                      filterOption={(input, option) =>
                        (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {companyUserList &&
                        companyUserList.map((el) => (
                          <Option key={el.id} value={el.id}>
                            {`${el.first_name} ${el.last_name || ""}`}
                          </Option>
                        ))}
                    </Select>
                  </div>
                </div>

                {/* Leave Mode Selector */}
                <div className="col-md-6 mb-3">
                  <div className={`float-select-wrap ${leaveMode ? "has-value" : ""}`}>
                    <label>
                      Leave Mode*
                      <Tooltip title="Select whether you're applying for a full day or a half day leave." placement="top">
                        <i className="fa fa-info-circle float-label-helper-icon" />
                      </Tooltip>
                    </label>
                    <Select
                      value={leaveMode}
                      onChange={(val) => {
                        setLeaveMode(val);
                        if (val === "full") {
                          setStartTime(null);
                          setEndTime(null);
                        }
                        setToDate(null);
                        setNumberOfDays(0);
                        setLeavesDates([]);
                      }}
                    >
                      <Option value="full">Full Day</Option>
                      <Option value="half">Half Day</Option>
                    </Select>
                  </div>
                </div>

                {/* Leave Type */}
                <div className="col-md-6 mb-3">
                  <div className={`float-select-wrap ${leaveType ? "has-value" : ""}`}>
                    <label>
                      Leave Type*
                      <Tooltip title="Select the leave type." placement="top">
                        <i className="fa fa-info-circle float-label-helper-icon" />
                      </Tooltip>
                    </label>
                    <Select
                      placeholder=""
                      value={leaveType || undefined}
                      onChange={(val) => setLeaveType(val)}
                    >
                      {leavePolicyList &&
                        leavePolicyList.map((el) => (
                          <Option key={el.leave_policy_id ?? el.policy_id ?? el.id} value={el.leave_policy_id ?? el.policy_id ?? el.id}>
                            {el.leave_type_name}
                          </Option>
                        ))}
                    </Select>
                  </div>
                </div>

                {/* Dates Section */}
                <div className="col-md-6 mb-3">
                  <div className={`float-select-wrap ${fromDate ? "has-value" : ""}`}>
                    <label>
                      {leaveMode === "half" ? "Date*" : "Start Date*"}
                      <Tooltip title="Select the Starting date." placement="top">
                        <i className="fa fa-info-circle float-label-helper-icon" />
                      </Tooltip>
                    </label>
                    <DatePicker
                      disabledDate={(current) => current && disabledFromDate(current)}
                      allowClear={false}
                      placeholder=""
                      value={fromDate ? moment(fromDate) : null}
                      onChange={(date) => {
                        setFromDate(date);
                        setToDate(null);
                      }}
                      format="DD-MM-YYYY"
                    />
                  </div>
                </div>

                {leaveMode === "full" && (
                  <div className="col-md-6 mb-3">
                    <div className={`float-select-wrap ${toDate ? "has-value" : ""}`}>
                      <label>
                        End Date*
                        <Tooltip title="Select the end date." placement="top">
                          <i className="fa fa-info-circle float-label-helper-icon" />
                        </Tooltip>
                      </label>
                      <DatePicker
                        allowClear={false}
                        placeholder=""
                        disabledDate={(current) => current && disabledToDate(current)}
                        value={toDate ? moment(toDate) : null}
                        onChange={(date) => setToDate(date)}
                        format="DD-MM-YYYY"
                      />
                    </div>
                  </div>
                )}

                {/* Half Day Times */}
                {leaveMode === "half" && (
                  <>
                    <div className="col-md-6 mb-3">
                      <div className={`float-select-wrap ${halfDayType ? "has-value" : ""}`}>
                        <label>
                          Shift Type*
                          <Tooltip title="Select 1st or 2nd half shift." placement="top">
                            <i className="fa fa-info-circle float-label-helper-icon" />
                          </Tooltip>
                        </label>
                        <Select
                          value={halfDayType}
                          onChange={(val) => setHalfDayType(val)}
                        >
                          <Option value="1st Half">1st Half</Option>
                          <Option value="2nd Half">2nd Half</Option>
                        </Select>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className={`float-select-wrap ${startTime ? "has-value" : ""}`}>
                        <label>
                          Start Time*
                          <Tooltip title="The starting time of the half-day leave." placement="top">
                            <i className="fa fa-info-circle float-label-helper-icon" />
                          </Tooltip>
                        </label>
                        <TimePicker
                          value={startTime}
                          onChange={(time) => setStartTime(time)}
                          format="h:mm a"
                          use12Hours
                          placeholder=""
                          style={{ width: "100%" }}
                          allowClear={false}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className={`float-select-wrap ${endTime ? "has-value" : ""}`}>
                        <label>
                          End Time (Auto)
                          <Tooltip title="Automatically calculated end time for half-day." placement="top">
                            <i className="fa fa-info-circle float-label-helper-icon" />
                          </Tooltip>
                        </label>
                        <TimePicker
                          value={endTime}
                          format="h:mm a"
                          use12Hours
                          placeholder=""
                          style={{ width: "100%", backgroundColor: "#f8f9fa" }}
                          disabled
                        />
                      </div>
                    </div>
                    {totalTimeDisplay && (
                      <div className="col-md-6 mb-3 d-flex align-items-center">
                        <small className="text-muted">Expected Duration: <strong>{totalTimeDisplay}</strong></small>
                      </div>
                    )}
                  </>
                )}

                {/* Days Display */}
                {numberOfDays > 0 && (
                  <div className="col-12 mb-3">
                    <div className="p-2 rounded border d-flex justify-content-between align-items-center" style={{ backgroundColor: "#fafafa" }}>
                      <span className="text-secondary small fw-medium">Total Days Calculated:</span>
                      <span className="badge bg-primary px-3 py-2" style={{ borderRadius: "5px" }}>{numberOfDays} {numberOfDays === 1 ? "Day" : "Days"}</span>
                    </div>
                  </div>
                )}

                {/* Policy Insights */}
                {selectedPolicyObj && (
                  <div className="col-12 mb-3">
                    <div className="alert border-0 p-2 mb-0" style={{ backgroundColor: "#e6fff1", borderRadius: "8px" }}>
                      <div className="d-flex justify-content-between">
                        <small style={{ color: "#00a651" }}><strong>Available:</strong> {selectedPolicyObj.remaining_leaves || 0} days</small>
                        <small style={{ color: "#00a651" }}><strong>Max Consecutive:</strong> {selectedPolicyObj.consecutive_allowed || 1} days</small>
                      </div>
                    </div>
                  </div>
                )}

                {/* Reason */}
                <div className="col-12 mb-1">
                  <div className={`float-input-wrap ${leaveReason ? "has-value" : ""}`}>
                    <TextArea
                      value={leaveReason}
                      onChange={(e) => setLeaveReason(e.target.value)}
                      placeholder=" "
                      autoSize={{ minRows: 2, maxRows: 6 }}
                      style={{}}
                    />
                    <label>
                      Reason*
                      <Tooltip title="Reason of employee leave." placement="top">
                        <i className="fa fa-info-circle float-label-helper-icon" />
                      </Tooltip>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer border-0 pt-0 justify-content-end">
              <button
                type="submit"
                disabled={dataSubmitting}
                className="btn btn-primary waves-effect waves-light px-4"
                style={{ borderRadius: "8px", padding: "10px", fontWeight: "600" }}
              >
                {dataSubmitting ? "Processing..." : "+ Apply Leave"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddLeavesHr;
